export enum EquipmentTypeEnum {
    RECOMMENDATION_EQUIPMENT = "RecommendationEquipment",
    SERVICE_CUSTOMER_EQUIPMENT = "ServiceCustomerEquipment",
    UPDATE_EQUIPMENT = "UpdateEquipment",
    SURVEY_EQUIPMENT = "SurveyEquipment"
}
